import useListLocationGuestCommentData, {
  fwWingstopListLocationGuestCommentDataConfigs,
} from './guest/useListLocationGuestCommentData'
import useFwWingstopLocationIntraday, {
  fwWingstopLocationIntradayConfigs,
} from './intraday/useLocationIntraday'
import useListEmployeeDiscountData, {
  fwWingstopListEmployeeDiscountConfigs,
} from './lossPrevention/useListEmployeeDiscountData'
import useListEmployeeLossPreventionData, {
  fwWingstopListEmployeeLossPreventionConfigs,
} from './lossPrevention/useListEmployeeLossPreventionData'
import useFwWingstopLossPreventionOutliers, {
  fwWingstopLossPreventionOutliersConfigs,
} from './lossPrevention/useListEmployeeOutliers'
import useLocationOpsCompsBreakdownData, {
  fwWingstopLocationOpsCompsBreakdownDataConfigs,
} from './lossPrevention/useLocationOpsCompsBreakdownData'
import useFwWingstopLossPrevention, {
  fwWingstopLossPreventionConfigs,
} from './lossPrevention/useLossPrevention'
import useFwWingstopLocationDayPart, {
  fwWingstopLocationDayPartConfigs,
} from './storePerformance/useLocationDayPart'
import useFwWingstopLocationLaborOverview, {
  fwWingstopLocationLaborOverviewConfigs,
} from './storePerformance/useLocationLaborOverview'
import useFwWingstopLocationRevenueCenter, {
  fwWingstopLocationRevenueCenterConfigs,
} from './storePerformance/useLocationRevenueCenter'
import useFwWingstopStorePerformance, {
  fwWingstopStorePerformanceConfigs,
} from './storePerformance/useStorePerformance'
import {
  fwWingstopCheckAvgDayPartConfigs,
  fwWingstopChecksDayPartConfigs,
  fwWingstopSalesDayPartConfigs,
  useFwWingstopDayPartCheckAvg,
  useFwWingstopDayPartChecks,
  useFwWingstopDayPartSales,
} from './useDayPartOrderMode'
import {
  fwWingstopCheckAvgDigitalNondigitalConfigs,
  fwWingstopChecksDigitalNondigitalConfigs,
  fwWingstopSalesDigitalNondigitalConfigs,
  useFwWingstopDigitalNondigitalCheckAvg,
  useFwWingstopDigitalNondigitalChecks,
  useFwWingstopDigitalNondigitalSales,
} from './useDigitalNondigital'
import useFwWingstopDiscountAndVoid, {
  fwWingstopDiscountAndVoidConfigs,
} from './useDiscountAndVoid'
import useLastTwentyEightDaysTrendData, {
  fwWingstopLastTwentyEightDaysTrendDataConfigs,
} from './useLastTwentyEightDaysTrendData'
import {
  fwWingstopFlashSalesByOrderModeConfigs,
  useFwWingstopR365AverageWeeklySalesbyOrderMode,
  useFwWingstopR365TotalSalesPercentbyOrderMode,
  useFwWingstopR365TotalSalesbyOrderMode,
} from './useR365SalesByOrderMode'
import useSalesAlertDashboard, {
  salesAlertDashboardConfig,
} from './useSalesAlertDashboard'
import useFwWingstopSalesAndCompTickets, {
  fwWingstopSalesAndCompTicketsConfigs,
} from './useSalesAndCompTickets'
import useSmgBreakdownByStore, {
  fwWingstopSmgBreakdownByStoreConfigs,
} from './useSmgBreakdownByStore'
import useFwWingstopSystemwideOverview, {
  fwWingstopSystemwideOverviewConfigs,
} from './useSystemwideOverview'
import useTimeClock, { fwWingstopTimeClockConfigs } from './useTimeClock'

export const configs = {
  fwWingstopTimeClock: fwWingstopTimeClockConfigs,
  fwWingstopLastTwentyEightDaysTrendData:
    fwWingstopLastTwentyEightDaysTrendDataConfigs,
  fwWingstopLossPrevention: fwWingstopLossPreventionConfigs,
  fwWingstopLocationOpsCompsBreakdownData:
    fwWingstopLocationOpsCompsBreakdownDataConfigs,
  fwWingstopListEmployeeLossPrevention:
    fwWingstopListEmployeeLossPreventionConfigs,
  fwWingstopListEmployeeDiscount: fwWingstopListEmployeeDiscountConfigs,
  fwWingstopListLocationGuestCommentData:
    fwWingstopListLocationGuestCommentDataConfigs,
  fwWingstopSystemwideOverview: fwWingstopSystemwideOverviewConfigs,
  fwWingstopLossPreventionOutliers: fwWingstopLossPreventionOutliersConfigs,
  fwWingstopDiscountAndVoid: fwWingstopDiscountAndVoidConfigs,
  fwWingstopSalesAlertDashboard: salesAlertDashboardConfig,
  fwWingstopDigitalNondigitalSales: fwWingstopSalesDigitalNondigitalConfigs,
  fwWingstopDigitalNondigitalChecks: fwWingstopChecksDigitalNondigitalConfigs,
  fwWingstopDigitalNondigitalCheckAvg:
    fwWingstopCheckAvgDigitalNondigitalConfigs,
  fwWingstopDayPartSales: fwWingstopSalesDayPartConfigs,
  fwWingstopDayPartChecks: fwWingstopChecksDayPartConfigs,
  fwWingstopDayPartCheckAvg: fwWingstopCheckAvgDayPartConfigs,
  fwWingstopSalesAndCompTickets: fwWingstopSalesAndCompTicketsConfigs,
  fwWingstopSmgBreakdownByStore: fwWingstopSmgBreakdownByStoreConfigs,
  fwWingstopLocationIntraday: fwWingstopLocationIntradayConfigs,
  fwWingstopStorePerformance: fwWingstopStorePerformanceConfigs,
  fwWingstopLocationDayPart: fwWingstopLocationDayPartConfigs,
  fwWingstopLocationRevenueCenter: fwWingstopLocationRevenueCenterConfigs,
  fwWingstopLocationLaborOverview: fwWingstopLocationLaborOverviewConfigs,
  fwWingstopR365AverageWeeklySalesbyOrderMode:
    fwWingstopFlashSalesByOrderModeConfigs,
  fwWingstopR365TotalSalesPercentbyOrderMode:
    fwWingstopFlashSalesByOrderModeConfigs,
  fwWingstopR365TotalSalesbyOrderMode: fwWingstopFlashSalesByOrderModeConfigs,
}

export const api = {
  fwWingstopTimeClock: useTimeClock,
  fwWingstopLastTwentyEightDaysTrendData: useLastTwentyEightDaysTrendData,
  fwWingstopLossPrevention: useFwWingstopLossPrevention,
  fwWingstopLocationOpsCompsBreakdownData: useLocationOpsCompsBreakdownData,
  fwWingstopListEmployeeLossPrevention: useListEmployeeLossPreventionData,
  fwWingstopListEmployeeDiscount: useListEmployeeDiscountData,
  fwWingstopListLocationGuestCommentData: useListLocationGuestCommentData,
  fwWingstopSystemwideOverview: useFwWingstopSystemwideOverview,
  fwWingstopLossPreventionOutliers: useFwWingstopLossPreventionOutliers,
  fwWingstopDiscountAndVoid: useFwWingstopDiscountAndVoid,
  fwWingstopSalesAlertDashboard: useSalesAlertDashboard,
  fwWingstopDigitalNondigitalSales: useFwWingstopDigitalNondigitalSales,
  fwWingstopDigitalNondigitalChecks: useFwWingstopDigitalNondigitalChecks,
  fwWingstopDigitalNondigitalCheckAvg: useFwWingstopDigitalNondigitalCheckAvg,
  fwWingstopDayPartSales: useFwWingstopDayPartSales,
  fwWingstopDayPartChecks: useFwWingstopDayPartChecks,
  fwWingstopDayPartCheckAvg: useFwWingstopDayPartCheckAvg,
  fwWingstopSalesAndCompTickets: useFwWingstopSalesAndCompTickets,
  fwWingstopSmgBreakdownByStore: useSmgBreakdownByStore,
  fwWingstopLocationIntraday: useFwWingstopLocationIntraday,
  fwWingstopStorePerformance: useFwWingstopStorePerformance,
  fwWingstopLocationDayPart: useFwWingstopLocationDayPart,
  fwWingstopLocationRevenueCenter: useFwWingstopLocationRevenueCenter,
  fwWingstopLocationLaborOverview: useFwWingstopLocationLaborOverview,
  fwWingstopR365AverageWeeklySalesbyOrderMode:
    useFwWingstopR365AverageWeeklySalesbyOrderMode,
  fwWingstopR365TotalSalesPercentbyOrderMode:
    useFwWingstopR365TotalSalesPercentbyOrderMode,
  fwWingstopR365TotalSalesbyOrderMode: useFwWingstopR365TotalSalesbyOrderMode,
}
